export interface Package {
  /**
   * @param duration - The amount of time it takes for this package to deplete
   *
   */
  validity: string
  /**
   * @param devices - The number of devices that can connect
   *
   */
  sharedUsers: number
  /**
   * @param price - Price for the package
   *
   */
  planType: 'PAID' | 'FREE TRIAL' | 'AD'
  price?: number
  mediaUrls?: string
  quotaLimit: string | null
  /**
   * @param name - Pacakage name
   *
   */
  name: string
  /**
   * @param id - Server identifier
   *
   */
  id: string
}

export const themes = {
  blue: 'theme-blue',
  green: 'theme-green',
  red: 'theme-red',
  orange: 'theme-orange',
  yellow: 'theme-yellow',
  slate: 'theme-slate',
  stone: 'theme-stone',
  neutral: 'theme-neutral',
  violet: 'theme-violet',
  zinc: 'theme-zinc',
  rose: 'theme-rose',
  gray: 'theme-gray',
}

export interface HotspotProps {
  gatewayBaseUrl: string
  org: string
  router: string
}

export interface HotspotConfig {
  currency: string
  logo?: string
  dark?: boolean
  theme?: 'green' | 'blue' | 'red' | 'orange' | 'slate' | 'stone' | 'neutral' | 'violet' | 'zinc' | 'rose' | 'gray' | 'yellow' | undefined
  background?: string
  tawkUrl?: string
  contactPhone?: string
  contactEmail?: string
}

export interface PackageProps {
  duration: string
  devices: string
  price: string
  id?: string
  name?: string
  currency?: string
  type?: 'PAID' | 'AD' | 'FREE'
  quota?: string
  isFeatured?: boolean
  isBestValue?: boolean
  onSelect?: () => void
  handleDialogClose?: (open: boolean) => void
}
